export const DA_REPORT_AVAILABLE_DATE = '2022-02';
export const MISSED_SAVINGS_REPORT_AVAILABLE_DATE = '2023-01';
export const AUTOMATION_REPORT_AVAILABLE_DATE = '2023-09-01';
